import script from "./TagSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagSelect.vue?vue&type=script&lang=ts&setup=true"

import "./TagSelect.vue?vue&type=style&index=0&id=4559c3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4559c3da"]])

export default __exports__